// @flow

import React from 'react';
import {Field} from "redux-form";
import {FormGroup, Input, Label} from "reactstrap";
import _ from "lodash";


const renderCheckboxGroup = ({
                                 input,
                                 id,
                                 label,
                                 className,
                                 meta: {touched, error, warning},
                                 children
                             }) => {
        const {onChange} = input;

        let array = [...input.value];
        let data = React.Children.map(children, (c) => {
            return {
                label: c.props.label,
                value: c.props.value,
                selectAll: c.props.selectAll
            };
        });
        return (
            <FormGroup>
                {label &&
                <Label>{label}</Label>
                }
                <div className={className ? "form-control " + className : "form-control"}  style={className ? {} : {height : 'auto'}}>
                    {
                        _.map(data, (d, i) =>
                            (
                                <div className={"form-check"} key={i}>
                                    {
                                        // For Select All Option:
                                        // auto-check other options when checked, auto-uncheck others when unchecked
                                        d.selectAll &&
                                        <Input className={"form-check-input"} onChange={(e) => {
                                            if (e.target.checked) {
                                                array = _.map(data, (item) => {return item.value;});
                                            } else {
                                                _.remove(array);
                                            }
                                            return onChange(array);
                                        }} type={"checkbox"} id={id + "-" + d.value} checked={_.includes(array, d.value)}/>
                                    ||
                                        !d.selectAll &&
                                        <Input className={"form-check-input"} onChange={(e) => {
                                            if (e.target.checked) {
                                                array.push(d.value);
                                            } else {
                                                _.remove(array, e => e === d.value);
                                                // If defined Checkbox Item contain select All Attribute, un-check it
                                                var selectAllOption = _.find(data, item => (item.selectAll));
                                                _.remove(array, e => e === selectAllOption.value);
                                            }
                                            return onChange(array);
                                        }} type={"checkbox"} id={id + "-" + d.value} checked={_.includes(array, d.value)}/>
                                    }
                                    <label className={"form-check-label"} htmlFor={id + "-" + d.value}>
                                        {d.label}
                                    </label>
                                </div>
                            ))
                    }
                </div>
            </FormGroup>
        )
    };

export function ReduxFormCheckboxGroupItem(props: {label: string, value: string}) {
    return null;
}

export default function ReduxFormCheckboxGroup(props: any) {

    return (
        <Field component={renderCheckboxGroup} {...props} />
    );
}


// WEBPACK FOOTER //
// ./src/components/form/ReduxFormCheckboxGroup.js